import { ALL } from '@/constant';
import { useShippingStatusCountQuery } from '@/generated/graphql-react-query';
import { IReportControl } from '@/types/report/type';

export const useShippingStatusCountHook = ({
  startDate,
  endDate,
  brandId,
  channel,
  gift,
  orderStatus,
  paymentStatus,
  shippingStatus,
  salesCode,
  countryId,
}: IReportControl) => {
  const { data, isLoading } = useShippingStatusCountQuery({
    input: {
      filter: {
        countryId,
        startOrderedAt: startDate,
        endOrderedAt: endDate,
        ...(brandId !== ALL && { brandId }),
        ...(channel !== ALL && { channel }),
        ...(gift !== ALL && { giftType: gift }),
        ...(orderStatus !== ALL && { orderStatus }),
        ...(paymentStatus !== ALL && { paymentStatus: [paymentStatus] }),
        ...(shippingStatus !== ALL && { shippingStatus: [shippingStatus] }),
        ...(salesCode !== ALL && { salesCode: [salesCode] }),
      },
    },
  });

  return {
    data: data?.shippingStatusCount || {
      delivered: 0,
      delivering: 0,
      readytopick: 0,
      return: 0,
    },
    isLoading,
  };
};
